// eslint-disable-next-line max-classes-per-file
import StructureOptionsItem from '@Components/Results/structure/constants';

export class StructureToolbarOptionType {
  static SHOPPING_CART = 'StructureToolbarOptionType.SHOPPING_CART';

  static ZOOM = 'StructureToolbarOptionType.ZOOM';

  static OPTIONS = 'StructureToolbarOptionType.OPTIONS';
}

export class StructureToolbarContextMenuOptions {
  // allowed options items for context menu (three dots)
  static allowed = [StructureOptionsItem.COPY_STRUCTURE_TO_QUERY, StructureOptionsItem.COPY_SMILES, StructureOptionsItem.SYNTHESIS_OPTIONS];
}
